export default "__VITE_ASSET__DCsph2CG__"